<template>
    <div class="page1">
        <!-- <Header/> -->
        <div v-if="form.step == 0 || form.step == 1">
            <div class="row1 position-relative">
                <b-container>
                    <b-row class="info-teach">
                        <b-col cols="12" sm="6">
                            <span>
                                Trải nghiệm bài thi kiểm tra năng lực tiếng Anh chuẩn xác nhất được thiết kế bởi đội ngũ thầy cô, chuyên gia trong và ngoài nước.
                            </span>
                        </b-col>
                        <b-col cols="12" sm="6">
                            <div class="teacher-pg1">
                                <img src="@/assets/giao-vien.png">
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>

            <ContactForm
            v-model="form"
            :step="form.step"
            @change-step="ChangeStep"
            />

            <!-- error message -->

            <div v-if="error.msg">
                <div class="container">
                    <div class="text-center">
                        <p class="text-danger h4 bold">{{ error.msg }}</p>
                    </div>
                </div>
            </div>

            <!-- error message end -->


        </div>
        <div v-if="form.step == 2">
            <b-container fluid class="background-primary mt-5">
                <b-row class="">
                    <b-col>
                        <b-container>
                            <b-row class="">
                                <b-col cols='12' class="p-3">
                                    <h4 style="color: #0158a8;" class="text-center fs-2 fw-bold">Học viên vui lòng đọc thông tin sau về bài Test<br> và tự chọn bài Test phù hợp với trình độ của mình:</h4>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-col>
                </b-row>
            </b-container>
            <b-container class="mt-5">
                <div class="text-white mw-600 m-auto card bg-custom p-4">
                    <div>
                        <h5>Bài kiểm tra <strong>Mini IELTS</strong> test phù hợp với các bạn:</h5>
                        <ul>
                            <li>Chỉ theo học Tiếng Anh tại trường, chưa từng học tại các trung tâm ngoài</li>
                            <li>Chỉ mới tập trung học ngữ pháp - từ vựng căn bản, không tập trung học các kỹ năng Nghe - Nói</li>
                            <li>Có điểm trung bình môn Tiếng Anh tại trường &lt; 8.0</li>
                            <li>Mong muốn thi chứng chỉ A2, B1 (hoặc PET, KET của Cambridge)</li>
                        </ul>
                    </div>
                    <div>
                        <h5>Bài kiểm tra <strong>Full IELTS</strong> Test phù hợp với các bạn: </h5>
                        <ul>
                            <li>Có kiến thức nền tảng và điểm trung bình môn Tiếng Anh tại trường từ 8 điểm trở lên</li>
                            <li>Đã từng tham gia các khóa học Tiếng Anh tại trung tâm ngoài, cũng như học theo định hướng phát triển các kỹ năng Nghe – Nói</li>
                            <li>Đã từng làm quen với IELTS hoặc các lớp luyện thi IELTS</li>
                            <li>Đã từng thi một số chứng chỉ và đạt 3.0 – 3.5 IELTS, , 400 TOEIC, 30-40 TOEFL iBT, hoặc A2 (theo khung Châu Âu) trở lên</li>
                        </ul>
                    </div>
                    <b-form class="qanda mt-5">
                        <b-form-group class="mb-4 text-dark" id="input-group-4" label="Bạn tự đánh giá mình phù hợp với bài test nào?" label-for="input-4">
                            <b-form-radio-group stacked v-model="form.examchoose" id="checkboxes-4">
                                <b-form-radio value="0">a. Mini IELTS test</b-form-radio>
                                <b-form-radio value="1">b. Full IELTS test</b-form-radio>
                                <b-form-radio value="2">c. Chưa xác định</b-form-radio>
                                <b-form-invalid-feedback style="margin-top: 15px;" :state="checkExamChoose">Bạn vui lòng trả lời câu hỏi trên</b-form-invalid-feedback>
                            </b-form-radio-group>
                        </b-form-group>
                        <div class="w-100 text-center">
                            <b-button @click="form.step = 1" variant="dark" class="mx-2">PREVIOUS</b-button>
                            <b-button @click="checkStep2()" class="btn-custom" variant="success">NEXT</b-button>
                        </div>
                    </b-form>
                </div>
            </b-container>
        </div>
        <div v-if="form.step == 3">
            <b-container fluid class="background-primary mt-5">
                <b-row class="">
                    <b-col>
                        <b-container>
                            <b-row class="">
                                <b-col cols='12' class="p-3">
                                    <h4 style="color: #0158a8;" class="text-center fs-2 fw-bold">Nếu bạn chưa xác định được bài test phù hợp, vui lòng trả lời câu hỏi sau để chúng tôi có thể gợi ý bài test phù hợp với bạn:</h4>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-col>
                </b-row>
            </b-container>
            <b-container class="mt-5">
                <div class="text-white mw-600 m-auto card bg-custom p-4">
                    <b-form class="qanda">
                        <b-form-group class="mb-4 text-dark" id="input-group-4" label="Bạn thuộc đối tượng nào dưới đây:" label-for="input-4">
                            <b-form-radio-group stacked v-model="form.examchoose2" id="checkboxes-4">
                                <b-form-radio value="0">a. Đã từng học hoặc từng thi IELTS/ TOEIC/ TOEFL iBT</b-form-radio>
                                <b-form-radio value="1">b. Đã từng học hoặc thi chứng chỉ KET, PET, FIRST của Cambridge hoặc chứng chỉ A2-B1-B2 </b-form-radio>
                                <b-form-radio value="2">c. HSG tiếng Anh cấp thành phố trở lên hoặc đã tham gia hùng biện/ thuyết trình tiếng Anh</b-form-radio>
                                <b-form-radio value="3">d. Điểm trung bình tiếng Anh trên lớp > 8.0</b-form-radio>
                                <b-form-radio value="4">e. Ko có lựa chọn nào ở trên</b-form-radio>
                                <b-form-invalid-feedback style="margin-top: 15px;" :state="checkExamChoose2">Bạn vui lòng chọn 01 câu trả lời phù hợp bên trên</b-form-invalid-feedback>
                            </b-form-radio-group>
                        </b-form-group>
                        <div class="w-100 text-center">
                            <b-button @click="form.step = 2" variant="dark" class="mx-2">PREVIOUS</b-button>
                            <b-button @click="checkStep3()" class="btn-custom mx-2" variant="success">NEXT</b-button>
                        </div>
                    </b-form>
                </div>
            </b-container>
        </div>
    </div>
</template>
<script>


import {
    BFormGroup
} from 'bootstrap-vue'

import ContactForm from '@/components/ContactForm.vue'

// mixins import
import Page1 from '@/plugins/TestPlugin/mixins/page1'

export default {
    mixins: [Page1],
    created() {
    },
    components: {
        BFormGroup,
        ContactForm
    },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    beforeUpdate() {
    },
    destroyed() {
    },
    updated() {
    }

}
</script>
<style>
    .btn-custom{
        position: relative;
        z-index: 100;
    }
    .bg-custom {
        background-color: #005db3bd !important;
        border: none;
        border-radius: 10px;
    }
    .modal .form-control {
        box-shadow: none !important;
    }

    form.qanda select:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }

    form.qanda .custom-control-input {
        position: inherit !important;
        border: none !important;
    }

    form.qanda .custom-control-label {
        padding-left: 10px !important;
    }

    form.qanda {
        /* width: 640px; */
        margin: auto;
    }

    form.qanda select {
        width: 300px;
        font-weight: 600;
        color: #000;
        border: none;
        border-radius: 7px;
    }

    form.qanda .form-group>label {
        font-size: 20px;
        color: #fff;
        line-height: 24px;
        margin-bottom: 5px;
    }

    form.qanda .custom-radio {
        background-color: #fff;
        padding: 7px 10px;
        height: 100% !important;
        width: 100% !important;
        border-radius: 7px;
        font-weight: 600;
        margin-top: 20px;
        display: inline-flex;
    }

    .invalid-feedback {
        display: none;
        width: 100%;
        margin-top: -10px;
        margin-bottom: 11px;
        font-weight: 700;
        font-size: 16px;
        color: #dc3545;
    }
    input[type=radio].is-invalid{
        background-color: #dc3545;
    }
    .checkbox-form .checkbox>div {
        padding: 0;
        margin: 0;
        margin-top: 6px;
    }

    .checkbox-form .checkbox>div input {
        display: inline;
        width: 100%;
        height: 15px;
        top: -13px;
    }

    .checkbox-form .checkbox>div label {
        display: block;
        width: 100%;
    }

    .custom-select {
        display: inline-block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem 1.75rem .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        vertical-align: middle;
        background: #fff url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center/8px 10px;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    .custom-control-label:before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
</style>
<style scoped>
    .mw-500 {
        max-width: 500px;
    }
    .mw-600 {
        max-width: 640px;
    }
    .background-primary {
        background-color: #87d2fd;
        padding: 20px;
    }

    .page1{
        /* height: 100vh; */
        padding-bottom: 200px;
        position: relative;
    }
    .button-pg1 {
            top: -5px;
    }
    .info-teach{
        display: flex;
        align-items: center;
        width: 65%;
        margin: auto;
        margin-top: 30px;
        position:relative;
    }
    .info-teach span{
        color: #0158a8;
        font-size: 18px;
        font-weight: 700;
        top: -15px;
        position: relative;
    }
    .row1::before{
        content: '';
        position: absolute;
        background-color: #87d2fd;
        width: 100%;
        height: 135px;
        top: 30px;
    }
    .teacher-pg1{
        position: relative;
        top: -35px;
    }
    .form-info{
        width: 45%;
        max-width: 450px;
        margin: auto;
    }
    .title-form h5{
        text-align: center;
        color: white;
        font-weight: 700;
        margin-top: 15px;
    }
    .form-control::-webkit-input-placeholder {
        color: #0158a8;
    }
    .cloudy-pg1{
        position: absolute;
        z-index: 0;
        height: 143px;
        width: 100%;
        bottom: 100px;
    }
    .cloudy-pg1 img{
        width: 100%;
    }
    /* .cloudy-pg1::before{
        content: '';
        position: absolute;
        background-image: url('~@/assets/cloudy.png');
        height: 170px;
        width: 1920px;
        background-size: 100% 100%;
    } */
    .input-group-5{
        display: flex;
        align-items: center;
        border-radius: 15px;
        color: #0158a8;
        margin-bottom: 18px;
        font-weight: 600;
        box-shadow: 0px 4px 3px #1b96f2;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        -webkit-appearance: none;
        -moz-appearance: none;height: 50px;
        padding: 15px;
        appearance: none;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .learn-check{
        margin: 0 35px 0 10px;
    }
    .custom-control {
        height: 20px;
        margin-top: -6px;
        top: 6px;
    }
    .custom-control-input {
        top: 10px;
    }
    .checkbox {
        display:flex;
        flex-direction:column;
        align-items: center;
        margin-left: 40px;
    }

    @media only screen and (max-width: 1200px){
        .form-info {
            width: 50%;
        }
    }

    @media only screen and (max-width: 992px){
        .form-info {
            width: 65%;
        }
    }

    @media only screen and (max-width: 768px){

        .page1{
            height: auto;
        }
        .info-teach{
            width: 100%;
            top: 20px;
        }
        .row1::before {
            top: 15px;
        }
        .info-teach span {
            font-size: 11px;
            top: 0;
        }
        .teacher-pg1 {
            top: 0;
        }
        .form-info {
            width: 100%;
        }
        .learn-check {
            margin: 0 0px 0 10px;
        }
        .checkbox{
            margin-left: 10px;
        }
        .row1 {
            margin-bottom: 45px;
        }
        .title-form h5 {
            font-size: 18px;
        }
        .input-group-5{
            height: auto;
            display: block;
            text-align: center;
            box-shadow: 0px 5px 10px #bac1c5;
            z-index: 9;
            position: relative;
        }
        .learn-check {
            padding-left: 0px;
            display: block;
            margin-bottom: 20px;
        }
        .input-group-5 .checkbox{
            display: inline-block !important;
        }
        .input-group-5 .checkbox:last-child{
            margin-left: 30px;
        }
        .cloudy-pg1{
            bottom: -160px;
        }
        .btn-custom.btn-success{
            font-size: 25px;
        }
    }
    @media only screen and (min-width: 1024px)  and (max-width: 1400px){
        .cloudy-pg1{
            bottom: -220px;
        }
    }
    @media only screen and (min-width: 1024px)  and (max-width: 1200px){
        .info-teach {
            width: 75%;
        }
    }

    @media only screen and (min-width: 1024px)  and (max-width: 1200px){
        .info-teach {
            width: 85%;
        }
    }
    @media only screen and (min-width: 768px)  and (max-width: 1023px){
        .info-teach span{
            font-size: 17px;
        }
        .info-teach {
            width: 100%;
            top: 16px;
        }
        .row1{
            margin-bottom: 10px;
        }
    }
    @media only screen and (min-width: 414px)  and (max-width: 735px){
        .info-teach span {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 1400px){
        .page1>.row1::before {
                top: 12px;
        }
    }
   
   @media only screen and (max-width: 1200px){
        .page1>.row1::before {
                top: 28px;
        }
    }
  
  @media only screen and (max-width: 1024px){
        .page1>.row1::before {
                top: 60px;
        }
    }

    @media only screen and (max-width: 955px){
        .page1>.row1::before {
                top: 45px;
        }
    }

    @media (max-width: 680px){
        form.qanda {
            width: unset;
        }

        form.qanda .custom-radio {
            margin-top: 10px;
        }
    }

    @media only screen and (max-width: 680px){
        .page1>.row1::before {
                top: 40px;
        }
    }

    @media only screen and (max-width: 576px){
        .page1>.row1::before {
                top: 28px;
        }
    }

    @media only screen and (max-width: 576px){
        .page1>.row1::before {
                top: 5px;
        }
    }


</style>